import React, { CSSProperties } from "react";
import Rate from "common/Rate/Rate";

interface GroupDollarRate {
  priceNumber: number;
  style?: CSSProperties;
}

const SubGroupDollarRate = ({ priceNumber, style }: GroupDollarRate) => {
  return (
    <Rate
      character="$"
      disabled
      count={4}
      defaultValue={priceNumber}
      style={{ fontSize: 14, ...style }}
    />
  );
};

export default SubGroupDollarRate;
